module.exports = __webpack_public_path__ + "static/media/xenyy.f33fb295.svg";